import Box from "@mui/material/Box";
import { ShiftTypes } from "../../utils/constants";

export function DashboardShiftRow({ ShiftDuties }: any) {
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <>
      <Box
        sx={{
          width: "100%", 
          maxHeight: "500px",
          overflowY: "auto", 
          backgroundColor: "#F9F9F9", 
          padding: "10px",
          borderRadius: "8px", 
          boxShadow: "0px 3px 8px 0px #0000001A", 
        }}
      >
        {ShiftDuties?.map((shift: any, index: any) => (
          <Box
            key={index}
            sx={{
              width: "90%",
              backgroundColor: "white",
              borderRadius: "6px",
              height: "85px",

              boxShadow: "0px 3px 8px 0px #0000001A",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              margin: "auto",
              marginTop: "12px",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: "400",
                boxShadow: "0px 0.5px 5px 0px #00000040",
                lineHeight: "21px",
                color: "#2C323D",
                backgroundColor: "#FFFFFF",
                borderRadius: "10px",
                border: "1px solid #D9D9D9",
                height: "37px",
                marginBottom: "5px",
                marginLeft: "20px",
                padding: "7px",
                width: "110px",
              }}
            >
              {formattedDate}
            </Box>
            <Box
              sx={{
                width: "150px",
                textAlign: "center",
                color: "black",
                fontSize: { md: "14px", lg: "18px" },
                fontWeight: "500",
                lineHeight: "27px",
              }}
            >
              {shift?.shift_type === ShiftTypes.MORNING
                ? "MORNING SHIFT"
                : shift?.shift_type === ShiftTypes.EVENING
                ? "EVENING SHIFT"
                : shift?.shift_type === ShiftTypes.NIGHT
                ? "NIGHT SHIFT"
                : ""}
            </Box>
            <Box
              sx={{
                width: "250px",
                textAlign: "center",
                color: "black",
                fontSize: { md: "14px", lg: "18px" },
                fontWeight: "500",
                lineHeight: "27px",
              }}
            >
              {`${shift?.start_time} - ${shift?.end_time}`}
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                height: "100%",
                marginLeft: "5px",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  height: "48px",
                  marginRight: "0px",
                  width: "9px",
                  borderTopLeftRadius: "5px",
                  borderBottomLeftRadius: "5px",
                  background:
                    index % 2 === 0
                      ? "linear-gradient(180deg, rgba(222, 226, 12, 0.15) 0%, rgba(226, 192, 12, 0.4) 0.01%, rgba(238, 201, 7, 0.27) 100%)"
                      : "linear-gradient(180deg, rgba(12, 226, 59, 0.15) 0%, rgba(12, 226, 59, 0.4) 0.01%, rgba(7, 238, 183, 0.27) 100%)",
                }}
              ></Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignContent: "center",
                  justifyContent: "center",
                  boxShadow: "0px 0.5px 5px 0px #00000040",
                  color: "#2C323D",
                  width: "200px",
                  height: "100%",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "1px",
                  borderTopRightRadius: "7px",
                  borderBottomRightRadius: "7px",
                  border: "1px solid #D9D9D9",
                  marginBottom: "5px",
                  padding: "7px",
                }}
              >
                <Box
                  sx={{
                    fontSize: "18px",
                    fontWeight: "400",
                    lineHeight: "27px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {shift?.pharmacyStaff?.name}
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
}
